<template>
  <div>
    <div class="content-i">
      <div class="content-box col-sm-12 col-md-8 col-lg-6">
        <div class="element-wrapper">
          <h6 class="element-header"> {{t('titleAddInvoicingFreeText', 'titleAddInvoicingFreeText')}}</h6>
          <div class="element-box">
            <div class="element-info">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <div class="os-icon os-icon-file">
                      </div>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header"> {{t('titleAddInvoicingFreeText', 'titleAddInvoicingFreeText')}} </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="element-wrapper pb-0 pt-0">
              <ResponseInfo class="px-0 py-0" v-if="getResponseInfo.responseName == 'invoicingFreeTextAddView'" />
              <ResponseInfo class="px-0 py-0" v-else-if="getResponseInfo.responseName == 'invoicingFreeTextView'" />
            </div>
            <div class="content-i" v-if="newInvoicingFreeTextItem">
              <div class="content-box px-0 py-0">
                <div class="element-wrapper pt-0 pb-0">
                  <AddFreeTextInvoiceForm :invoicing-free-text-item="newInvoicingFreeTextItem"></AddFreeTextInvoiceForm>
                </div>
                <div class="col-12 d-flex justify-content-end mt-3">
                  <button v-if="!loading && newInvoicingFreeTextItem" class="btn btn-primary" type="button" @click="addInvoicingFreeText" > {{ t('addButtonText', 'addButtonText') }} </button>
                  <b-button v-else variant="primary" disabled>
                    {{t('addButtonText', 'addButtonText')}}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import ResponseInfo from '@/components/ResponseInfo.vue'
import AddFreeTextInvoiceForm from "@/components/Invoicing/AddFreeTextInvoiceForm";

export default {
  name: 'AddFreeTextInvoice',
  components: {
    ResponseInfo,
    AddFreeTextInvoiceForm
  },
  data() {
    return {
      loading: false,
      newInvoicingFreeTextItem: {
        batch_type: null,
        description: null,
        issue_tracker_num: null,
        quantity: null,
        vat_code: 0,
        one_off: 0,
        total: null,
        status: null,
        rate: null,
        principle: null
      },
    }
  },
  computed: {
    ...mapGetters(['getResponseInfo']),
  },
  methods: {
    clearData() {
      this.newInvoicingFreeTextItem = {
        batch_type: null,
        description: null,
        issue_tracker_num: null,
        quantity: null,
        vat_code: 0,
        one_off: 0,
        total: null,
        status: null,
        rate: null,
        principle: null
      }
    },
    addInvoicingFreeText() {
      this.$store.dispatch('addInvoicingFreeText', {
        item: this.newInvoicingFreeTextItem,
      }).then(() => {
        let responseStatus = this.getResponseInfo.status
        if (responseStatus !== 'error' && responseStatus !== 'warning') {
          switch (this.newInvoicingFreeTextItem.status) {
            case 'ready':
              this.$router.push({ name: 'free_text_invoice_to_do', query: {page: 1, per_page: 20}})
              break
            case 'queried':
              this.$router.push({ name: 'free_text_invoice_queried', query: {page: 1, per_page: 20}})
              break
            case 'generated':
              this.$router.push({ name: 'free_text_invoice_completed', query: {page: 1, per_page: 20}})
              break
          }
          this.clearData()
        }
      })
    },
    loadInvoiceTypes() {
      this.$store.dispatch('loadBatchTypesAndPrincipalsForInvoicing')
    },
  },
  created() {
    this.loadInvoiceTypes()
    this.$store.dispatch('alertClearResponse')
  }
}


</script>

<style scoped>

</style>
